import { useTranslation } from "react-i18next";
import { Header } from 'datastake-daf/dist/components';
import { NOTIFICATION_MODE, useForms } from "../../../../../context/Forms";
import { usePermissions } from "../../../../../permissions/usePermissions";
import { useMemo } from "react";
import { renderBreadCrumbs } from "../../../../../helpers/breadCrumbs";
import { useNavigate } from "react-router-dom";

export default function SettingsHeader({
  type = 'edit',
  changed = false,
  onSave = () => { },
  goToEdit = () => { },
  goToView = () => { },
  mod,
}) {
  const goTo = useNavigate();
  const { t } = useTranslation();
  const { notificationMode, changeNotificationState } = useForms();
  const canEdit = usePermissions({ permission: 'settings.canEdit' });

  const breadCrumbs = useMemo(() =>
    renderBreadCrumbs({ t, view: 'settings', goTo, mod, isView: true }), [t, goTo]);

  const extra = () => {
    if (!canEdit) {
      return [];
    }

    if (type === 'edit') {
      return [
        {
          disabled: !changed,
          onClick: () => onSave(true),
          label: t('Save'),
          type: 'primary',
        },
        {
          onClick: () => {
            if (notificationMode === NOTIFICATION_MODE.PROJECT_SOURCES) {
              changeNotificationState({
                onYes: () => goToView()
              });
            } else {
              goToView();
            }
          },
          label: t('Cancel'),
        },
      ]
    }

    return [
      {
        onClick: () => goToEdit(),
        label: t('Edit'),
        type: 'primary',
      },
    ];
  };

  return (
    <Header
      breadcrumbs={breadCrumbs}
      title={t('Settings')}
      onDownload={() => { }}
      actionButtons={extra()}
    />
  )
}
